import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { PARTNERS, getPartnerByPath } from "@/config/partners";

const PartnerContext = createContext({ partner: null, config: null, linkBase: "", isPartner: false });

export const PartnerProvider = ({ children }) => {
  const { pathname } = useLocation();
  const host = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
  const subdomain = host.split(".")[0];
  const firstSegment = pathname.split("/").filter(Boolean)[0] || "";

  // Detección por subdominio (ej: partner.operasafe.cl) o por ruta (ej: /partner).
  const bySubdomain = PARTNERS.find((p) => p.path.toLowerCase() === subdomain) || null;
  const config = bySubdomain || getPartnerByPath(firstSegment);
  const matchedByHost = !!bySubdomain;

  // En el subdominio la marca persiste sola; vía ruta usamos el prefijo para conservar el contexto al navegar.
  const linkBase = config && !matchedByHost ? `/${config.path}` : "";

  return (
    <PartnerContext.Provider value={{ partner: config?.code || null, config, linkBase, isPartner: !!config }}>
      {children}
    </PartnerContext.Provider>
  );
};

export const usePartner = () => useContext(PartnerContext);
